import angular from 'angular';
import ngRoute from 'angular-route';
import routes from './support.routes';

import training from './training';
import releaseNotes from './releaseNotes';

export default angular.module('app.components.support', [
  ngRoute,
  training,
  releaseNotes,
])
  .config(routes)
  .name;

console.log('app.components.support created');
